import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyDbErLu-KHQAS1rjE1FdsHtwE6NdNK9InI",
  authDomain: "school-timetable-app-4b5d3.firebaseapp.com",
  databaseURL:
    "https://school-timetable-app-4b5d3-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "school-timetable-app-4b5d3",
  storageBucket: "school-timetable-app-4b5d3.firebasestorage.app",
  messagingSenderId: "426567578917",
  appId: "1:426567578917:web:cadf608a5c36cf552596cc",
};

const app = initializeApp(firebaseConfig);

export const db = getDatabase(app);